import React from "react";
import "./Wipe.css";

const Wipe = ()=>{
    return(
        <div className="wipe__container">
            <div className="wipe__wipe-animation"></div>
        </div>
    )
}

export default Wipe;